/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = ["body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}.divStyle[_ngcontent-%COMP%]{display:inline-block}.borderClassColor[_ngcontent-%COMP%]{border:.5px solid hsla(0,0%,5%,.3);border-radius:10px;margin-bottom:5px;background-color:#fff}"];
export { styles as styles };

